import {
  actions,
  getBusinessDatatableAsync,
  getBusinessByIdAsync,
  getBusinessGroupsByUserIdAsync,
  getBusinessByIdMultilingualAsync,
  createBusinessMultilingualAsync,
  editBusinessMultilingualAsync,
} from './slices';

export const BusinessActions = {
  ...actions,
  getBusinessDatatableAsync,
  getBusinessByIdAsync,
  getBusinessGroupsByUserIdAsync,
  getBusinessByIdMultilingualAsync,
  createBusinessMultilingualAsync,
  editBusinessMultilingualAsync,
};

export * from './types';
